import { render, staticRenderFns } from "./events-index.vue?vue&type=template&id=244c68ca"
import script from "./events-index.vue?vue&type=script&lang=js"
export * from "./events-index.vue?vue&type=script&lang=js"
import style0 from "./events-index.vue?vue&type=style&index=0&id=244c68ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports